import { Tooltips } from '@/enums';

export function formatFinancialValueByKPI(kpiKey, rawValue) {
  if (rawValue === null || rawValue === undefined || isNaN(Number(rawValue))) return '-';

  const value = Number(rawValue);

  const formatCurrency = (val) => {
    if (val >= 1_000_000) {
      return `$${(val / 1_000_000).toFixed(val % 1_000_000 === 0 ? 0 : 1)}M`;
    }
    if (val >= 1_000) {
      return `$${(val / 1_000).toFixed(val % 1_000 === 0 ? 0 : 1)}k`;
    }
    return `$${Math.round(val)}`;
  };

  const formatPercentage = (val) => `${(val * 100).toFixed(2)}%`;
  const formatRatio = (val) => `${val}:1`;
  const formatNumber = (val) => val.toFixed(2);

  switch (kpiKey) {
    case Tooltips.CREDITBOX_DEBT_COVERAGE_HEADER:
    case Tooltips.CREDITBOX_LIQUIDITY_HEADER:
      return formatNumber(value);
    case Tooltips.CREDITBOX_PROFITABILITY_HEADER:
    case Tooltips.CREDITBOX_COLLATERAL_COVERAGE_HEADER:
      return formatPercentage(value);
    case Tooltips.CREDITBOX_LEVERAGE_HEADER:
      return formatRatio(value);
    case Tooltips.CREDITBOX_CAPITAL_ADEQUACY_HEADER:
    case Tooltips.CREDITBOX_GUARANTOR_STRENGTH_HEADER:
      return formatCurrency(value);
    default:
      return formatNumber(value);
  }
}
